
import Carousel from '@/general/component/carousel/landing'
import MobileCarousel from '@/general/component/carousel/landing/mobile'
import Hero from '@/landing/template/home/HomeHero'
import Community from '@/landing/template/home/HomeCommunity'

import styled from 'styled-components'
const Wrapper = styled.div`
    position: relative;
    @media (min-width: 1400px) {
        padding: 0 1em;
    }
    @media (max-width: 640px) {
        padding: 0;
    }
`
export interface LandingHomeProps {
    language: string;
}
const Landing = ({ contents, language }:LandingHomeProps) => {
  return (
        <Wrapper>
            <Carousel language={language} />
            <MobileCarousel sliderData={contents.homeSliderBanner} />
            <div className='container mx-auto'>
                <Hero contents={contents} />
                <Community contents={contents} />
            </div>
        </Wrapper>
  )
}

export default Landing
